import styled from 'styled-components'

import MarkdownRender from 'LuxKit/MarkdownRender'
import BodyText from 'LuxKit/Typography/BodyText'
import { mediaQueryUp } from 'components/utils/breakpoint'

const StyledFacilities = styled(MarkdownRender)`
  > ul {
    columns: auto 2;
  }
`

const TwoColumns = styled.div`
  ${mediaQueryUp.tablet} {
    columns: 2;

    > * {
      break-inside: avoid;
    }
  }
`

const FacilitiesList = styled.ul`
  list-style-type: none;
  margin: 0;
`

export interface PropertyFacilityGroup {
  name: string
  items: Array<{ name: string }>
}

type Props = {
  facilities: string
} | {
  amenities: Array<PropertyFacilityGroup>
}

function PropertyFacilitiesContent(props: Props) {
  if ('facilities' in props) {
    return <StyledFacilities content={props.facilities} fontSize="medium" type="compact" />
  }

  return <TwoColumns>
    {props.amenities.map(amenityGroup => (
      <div key={amenityGroup.name}>
        <BodyText variant="medium" weight="bold">{amenityGroup.name}</BodyText>
        <FacilitiesList>
          {amenityGroup.items.map(item => (
            <li key={item.name}>{item.name}</li>
          ))}
        </FacilitiesList>
      </div>
    ))}
  </TwoColumns>
}

export default PropertyFacilitiesContent
